import { useEffect, useRef, useState } from 'react';

export function useTruncateIfOverflow(maxLines = 2) {
  const ref = useRef<HTMLParagraphElement>(null);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * maxLines;

    setTruncated(el.scrollHeight > maxHeight);
  }, [maxLines]);

  return { ref, truncated };
}
